export const genreOptions: string[] = [
  "全部类型",
  "情欲",
  "剧情",
  "爱情",
  "悬疑",
  "惊悚",
  "犯罪",
  "文艺",
  "治愈",
  "动作",
  "都市",
];

export const yearOptions: string[] = [
  "全部年份",
  "2023",
  "2022",
  "2021",
  "2020",
  "2019",
  "2018",
  "2017",
  "2016",
  "2015",
  "2014",
  "2013",
  "2012",
  "2011",
  "2010",
  "2009",
];

export const ratingOptions: string[] = [
  "全部评分",
  "8.5 分以上",
  "8.0 分以上",
  "7.5 分以上",
  "7.0 分以上",
];

export const sortOptions: string[] = [
  "综合排序",
  "评分最高",
  "年份最新",
  "最多浏览",
  "收藏最多",
];

export const PAGE_SIZE = 8;